import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import 'rxjs/add/operator/debounceTime'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/zip'
import 'rxjs/add/observable/merge'
import 'rxjs/add/observable/of'
import 'rxjs/add/observable/from'
import 'rxjs/add/observable/never'
import 'rxjs/add/observable/empty'
import { DataTypes } from './dataRedux'
import { TimestampTypes } from './timestampRedux'
import { getViewparams } from '../selectors/viewparamsSelector'
import functions from '../config/functions'

const DATA_REQUESTED = DataTypes.DATA_REQUESTED
const DATA_FULFILLED = DataTypes.DATA_FULFILLED
// const DATA_FAILED = DataTypes.DATA_FAILED
const BOUNDS_CHANGED = TimestampTypes.BOUNDS_CHANGED
const POINT_DATA_REQUESTED = DataTypes.POINT_DATA_REQUESTED

const dataFulfilled = (json, id) => ({
  type: DATA_FULFILLED,
  json,
  id
})

const formatDataUrl = (url, viewparams, idToken) => {
  const formattedUrl = `${url}&viewparams=${viewparams}&token=${idToken}`
  return formattedUrl
}

const formatPointDataUrl = (url, lng, lat, idToken) => {
  const formattedUrl = `${url}&viewparams=lon:${lng};lat:${lat};&token=${idToken}`
  return formattedUrl
}

export const pointDataEpic = (action$, store) =>
  action$
    .ofType(POINT_DATA_REQUESTED)
    .switchMap(({ lng, lat }) => {
      const { authenticated, idToken } = store.getState().login
      const { serviceCardActive: service } = store.getState().service

      if (!authenticated) {
        return Observable.empty()
      }

      const fetchArray = service.data
        .asMutable()
        .filter(datum => datum.type === 'point')
        .map((datum, index) => {
          return Observable.zip(
            Observable.of(datum.id),
            Observable.from(
              fetch(formatPointDataUrl(datum.url, lng, lat, idToken))
            ),
            (id, response) => ({ id, response })
          )
        })
      return Observable.merge(...fetchArray)
    })
    .catch(error => Observable.of({ type: 'ERROR' }))
    .mergeMap(({ id, response }) =>
      Observable.zip(
        Observable.of(id),
        Observable.from(response.json()),
        (id, json) => ({ id, json })
      )
    )
    .catch(error => Observable.of({ type: 'ERROR' }))
    .map(({ id, json }) => dataFulfilled(json, id))

export const dataEpic = (action$, store) =>
  action$
    .ofType(DATA_REQUESTED, BOUNDS_CHANGED)
    .debounceTime(2000)
    .switchMap(() => {
      const { authenticated, idToken } = store.getState().login
      const { serviceCardActive: service } = store.getState().service
      const data = service.data.filter(item => item)

      if (!authenticated) {
        return Observable.empty()
      }

      const state = store.getState()
      const viewparams = getViewparams(state)

      const fetchArray = data
        .asMutable()
        .filter(datum => datum.type === 'extent')
        .filter(datum => functions[datum.active](state))
        .map((datum, index) => {
          return Observable.zip(
            Observable.of(datum.id),
            Observable.from(
              fetch(formatDataUrl(datum.url, viewparams, idToken))
            ),
            (id, response) => ({ id, response })
          )
        })

      return Observable.merge(...fetchArray)
    })
    .mergeMap(({ id, response }) =>
      Observable.zip(
        Observable.of(id),
        Observable.from(response.json()),
        (id, json) => ({ id, json })
      )
    )
  .map(({ id, json }) => dataFulfilled(json, id))
  .catch(error => {
    console.log(error)
    return Observable.of({ type: 'ERROR' })
  })



// WEBPACK FOOTER //
// ./src/redux/dataEpic.js